import React from "react";
import { MapPin, Check } from "lucide-react";
import { CITIES } from "../../../lib/site";

const HIGHLIGHTS = [
  { city: "Prescott & Prescott Valley", desc: "Our central hub. Rapid scheduling and fully personalized local residential service." },
  { city: "Flagstaff", desc: "Heavy-duty commercial and industrial coatings engineered for high-elevation freeze cycles." },
  { city: "Sedona", desc: "Premium metallic artistic coatings and UV-stable outdoor patio sealants." },
];

const ServiceAreas = () => (
  <section className="py-20 md:py-24 bg-zinc-950 border-t border-zinc-900 text-left" data-testid="service-areas-section">
    <div className="max-w-7xl mx-auto px-5 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div>
        <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Serving Our Neighbors</span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mt-2 leading-tight">
          Prescott, Flagstaff, Sedona &amp; Beyond
        </h2>
        <p className="text-zinc-400 text-base md:text-lg mt-4 leading-relaxed">
          We travel throughout Northern Arizona so local homeowners and building managers get exceptional
          craftsmanship — whether it's a garage in Prescott, a patio in Sedona or a warehouse in Flagstaff.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-8">
          {CITIES.map((c) => (
            <div key={c} className="flex items-center space-x-2 text-zinc-300 text-sm">
              <MapPin className="w-4 h-4 text-[#C69453] shrink-0" />
              <span>{c}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-[#141414] border border-zinc-800 p-8 space-y-6">
        <h3 className="text-2xl font-semibold text-white">Primary Service Areas</h3>
        <ul className="space-y-5">
          {HIGHLIGHTS.map((h) => (
            <li key={h.city} className="flex items-start space-x-3">
              <Check className="w-5 h-5 text-[#C69453] shrink-0 mt-0.5" />
              <div>
                <h4 className="font-bold text-white">{h.city}</h4>
                <p className="text-zinc-400 text-sm">{h.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default ServiceAreas;
